import { useMemo, type FC, type PropsWithChildren } from 'react';

import { CalendarContext } from '@pages/Calendar/context/CalendarContext';

import { useCalendar, useCalendarEffects, useCalendarSettings } from '../hooks';

const { Provider } = CalendarContext;

export const CalendarProvider: FC<PropsWithChildren> = ({ children }) => {
  const {
    todayMoment,
    selectedDateMoment,
    selectedDateTitle,
    isTodaySelected,
    goToPrevDayHandler,
    goToNextDayHandler,
    returnToTodayHandler,
    validateDateSearchParamHandler,
    calendarDataRefreshKey,
    refreshCalendarData,
    displayedEmployeeIds,
    updateDisplayedEmployeeIds,
    addDisplayedEmployeeId,
    removeDisplayedEmployeeId,
    activeWorkdayEmployeeIds,
    updateActiveWorkdayEmployeeIds,
    addActiveWorkdayEmployeeId,
    removeActiveWorkdayEmployeeId,
    branchStartTime,
    branchEndTime,
    setBranchStartTime,
    setBranchEndTime,
  } = useCalendar();
  const {
    intervalHeightPx,
    intervalHeightSize,
    gridStepMinutes,
    maxVisibleColumnCount,
    preferredMaxColumns,
    updateGridStepMinutes,
    updateIntervalHeightSize,
    updateMaxVisibleColumnCount,
    updatePreferredMaxColumns,
    previewFields,
    updatePreviewFields,
  } = useCalendarSettings();

  useCalendarEffects({
    validateDateSearchParamHandler,
  });

  const value = useMemo(
    () => ({
      todayMoment,
      selectedDateMoment,
      selectedDateTitle,
      isTodaySelected,
      goToPrevDayHandler,
      goToNextDayHandler,
      returnToTodayHandler,
      calendarDataRefreshKey,
      refreshCalendarData,
      displayedEmployeeIds,
      updateDisplayedEmployeeIds,
      addDisplayedEmployeeId,
      removeDisplayedEmployeeId,
      activeWorkdayEmployeeIds,
      updateActiveWorkdayEmployeeIds,
      addActiveWorkdayEmployeeId,
      removeActiveWorkdayEmployeeId,
      intervalHeightPx,
      intervalHeightSize,
      gridStepMinutes,
      maxVisibleColumnCount,
      preferredMaxColumns,
      updateGridStepMinutes,
      updateIntervalHeightSize,
      updateMaxVisibleColumnCount,
      updatePreferredMaxColumns,
      previewFields,
      updatePreviewFields,
      branchStartTime,
      branchEndTime,
      setBranchStartTime,
      setBranchEndTime,
    }),
    [
      todayMoment,
      selectedDateMoment,
      selectedDateTitle,
      isTodaySelected,
      goToPrevDayHandler,
      goToNextDayHandler,
      returnToTodayHandler,
      calendarDataRefreshKey,
      refreshCalendarData,
      displayedEmployeeIds,
      updateDisplayedEmployeeIds,
      addDisplayedEmployeeId,
      removeDisplayedEmployeeId,
      activeWorkdayEmployeeIds,
      updateActiveWorkdayEmployeeIds,
      addActiveWorkdayEmployeeId,
      removeActiveWorkdayEmployeeId,
      intervalHeightPx,
      intervalHeightSize,
      gridStepMinutes,
      maxVisibleColumnCount,
      preferredMaxColumns,
      updateGridStepMinutes,
      updateIntervalHeightSize,
      updateMaxVisibleColumnCount,
      updatePreferredMaxColumns,
      previewFields,
      updatePreviewFields,
      branchStartTime,
      branchEndTime,
      setBranchStartTime,
      setBranchEndTime,
    ]
  );

  return <Provider value={value}>{children}</Provider>;
};
